import userService from '@/services/userService'
import Vue from 'vue'
import store from '@/store/store'

function updateUserStore (commit) {
    return new Promise((resolve, reject) => {
        var vssUserPromise = userService.getCurrentPortalUser(Vue.prototype.$http).then(response => {
            //loggingService.log(isDebug, 'auth', 'auth.userService.GetCurrentVssUserDto')
            commit('setVssUserDto', response.data)
            console.log('store - auth/authenticated') // eslint-disable-line
        }, err => {
            reject(err)
        })

        var agencyPromise = userService.getCurrentPortalUserAgency(Vue.prototype.$http).then(response => {
            commit('setUserAgencyDto', response.data)
        }, err => {
            reject(err)
        })

        Promise.all([vssUserPromise, agencyPromise]).then(results => {
            //loggingService.log(isDebug, 'auth', 'authenticated - post promises')
            resolve(results)
            //loggingService.log(isDebug, 'auth', 'auth.authenticated - post promises - ' + state.authenticated)
        }, err => {
            reject(err)
        })
    })
}

function requiresSetup () {
    let userDto = store.state.auth.vssUserDto || {}
    let agencyDto = store.state.auth.userAgencyDto || {}
    if (!!userDto && !!userDto.email && userDto.email.includes('@wyo.gov')) {
        if (!agencyDto) {
            return true
        } else {
            return !userDto.firstName || !userDto.lastName || !agencyDto.agencyId
        }
    } else {
        return !userDto.firstName || !userDto.lastName
    }
}

export default {
    updateUserStore: updateUserStore,
    requiresSetup: requiresSetup
}
